export const searchKeys = [
  'sale_type',
  'address',
  'price_max',
  'price_min',
  'odometer_max',
  'odometer_min',
  'year_max',
  'year_min',
  'make',
  'model',
  'trim',
  'category',
  'city',
  'location',
  'radius',
  'transmission_type',
  'ext_colour',
  'int_colour',
  'engine',
  'engine_type',
  'fuel_type',
  'sort',
  'title',
  'organization',
];

// Parameters an SRP can pin for the whole page via its shortcode attributes or WP
// custom filter, rather than leaving them to the visitor: a used-only SRP has no
// New/Used toggle, a dealer page has no organization picker. Whether one is
// actually pinned is decided per page in init-filters, by checking for a filter
// container — where the visitor can change it, it is not locked.
export const lockedScopeKeys = ['sale_type', 'organization'];

export const drilldown_metadata = [
  'address',
  'model',
  'ext_colour',
  'int_colour',
  'engine',
  'trim',
  'engine_type',
  'fuel_type',
];

export const baseSearchParameters = {
  sale_type: null,
  address: null,
  price_max: null,
  price_min: null,
  odometer_max: null,
  odometer_min: null,
  year_max: null,
  year_min: null,
  make: null,
  model: null,
  trim: null,
  category: null,
  city: null,
  location: null,
  radius: null,
  transmission_type: null,
  ext_colour: null,
  int_colour: null,
  engine_type: null,
  fuel_type: null,
  sort: null,
  title: null,
  organization: null,
};
